
import TxStreetApiVue from "@/mixins/TxStreetApi.vue";
import { defineComponent } from "vue";
import { Ad, Asset } from "../types";
import { useToast } from "vue-toastification";
import Connect from "./Connect.vue";
import { web3 } from "../lib/wallet";
const toast = useToast();

export default defineComponent({
  components: { Connect },
  name: "CreateAd",
  props: {
    date: {
      type: Date,
      required: true,
    },
    location: {
      type: String,
      required: true,
    },
  },
  mounted() {
    if (this.$store.state.connectedAddress) this.loadMoonHeads();
    this.getWaitTimes();
  },
  watch: {
    "$store.getters.allMyAssets": function () {
      this.getWaitTimes();
    },
    "$store.state.connectedAddress": function (val) {
      if (val) this.loadMoonHeads();
    },
  },
  data: function () {
    return {
      moonHeadPage: 1,
      loadingMoonHeads: false,
      newAd: {
        text: "",
        link: "",
        moonHeadId: 0,
        date: this.date,
        location: this.location,
      } as Ad,
    };
  },
  computed: {
    loc(): any {
      return this.$store.state.adLocations[this.location];
    },
    types(): string {
      let types = "";
      for (let i = 0; i < this.loc.types.length; i++) {
        const type = this.loc.types[i];
        if (i !== 0) types = types + "/";
        types = types + type;
      }
      if (this.loc.types.includes("image"))
        types =
          types +
          " (<a href='https://imgur.com/upload' target='_blank'>Imgur</a> link with size: " +
          this.loc.imageSizes +
          "px)";
      return types;
    },
  },
  methods: {
    dateToHour(date: Date) {
      let seconds = date.getTime() / 1000;
      let hours = Math.floor(seconds / 3600);
      return hours;
    },
    async loadMoonHeads() {
      if (this.loadingMoonHeads) return false;
      this.loadingMoonHeads = true;
      await this.$store.dispatch("getAssets", { page: this.moonHeadPage });
      await this.$store.dispatch("getZoomerAssets", { page: this.moonHeadPage });
      if (this.$store.getters.allMyAssets.length) this.moonHeadPage++;
      this.loadingMoonHeads = false;
    },
    getWaitTimes() {
      let ids = [];
      for (let i = 0; i < this.$store.getters.allMyAssets.length; i++) {
        const asset: Asset = this.$store.getters.allMyAssets[i];
        if (asset.name === "Sleeve") continue;
        if (this.$store.state.AdWaitTimes[asset.token_id]) continue;
        ids.push(asset.token_id);
      }
      if (ids.length) this.getAdWait(ids);
    },
    async create() {
      // console.log(this.newAd);

      let signature: any = await web3.eth.personal.sign(
        JSON.stringify(this.newAd),
        this.$store.state.connectedAddress,
        ""
      );
      // let body = JSON.stringify({
      //   address: this.$store.state.connectedAddress,
      //   message: JSON.stringify(this.newAd),
      //   signature: signature,
      // });

      // console.log(signature);
      let result = await this.createAd(this.$store.state.connectedAddress, this.newAd, signature);
      if (result.success) {
        toast.success("Ad reserved!");
        this.$store.dispatch("addEvent", {
          location: this.location,
          ad: {
            ...this.newAd,
            ...{ hour: this.dateToHour(this.date) },
          },
        });
        this.$store.commit("deleteAdWaitTime", this.newAd.moonHeadId);
        this.$store.commit("closeModal");
      }
    },
  },
  mixins: [TxStreetApiVue],
});
